import { render, staticRenderFns } from "./EditFieldShippingFilesMeta.vue?vue&type=template&id=672d6d26"
import script from "./EditFieldShippingFilesMeta.vue?vue&type=script&lang=js"
export * from "./EditFieldShippingFilesMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports